<div class="filter-wrapper">

    <div class="row g-3 align-items-end">

        <!-- Search -->
        <div class="col-xl-3 col-lg-4 col-md-6">
            <label class="filter-label">
                <i class="pi pi-search me-1"></i>
                Search
            </label>

            <span class="p-input-icon-left w-100">
                <i class="pi pi-search"></i>
                <input pInputText type="text" class="w-100 p-inputtext-sm" [placeholder]="searchPlaceholder"
                    [formControl]="searchControl" />
            </span>
        </div>

        <!-- Status -->
        @if(statusOptions.length){
        <div class="col-xl-3 col-lg-4 col-md-6">
            <label class="filter-label">
                <i class="pi pi-check-circle me-1"></i>
                Status
            </label>

            <p-dropdown [options]="statusOptions" [(ngModel)]="status" placeholder="All Status"
                styleClass="w-100 p-inputtext-sm" appendTo="body" (onChange)="onStatusChange()">
            </p-dropdown>
        </div>
        }

        <!-- Date -->
        <div class="col-xl-3 col-lg-4 col-md-6">
            <label class="filter-label">
                <i class="pi pi-calendar me-1"></i>
                Date Range
            </label>

            <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true" dateFormat="dd/mm/yy"
                [maxDate]="maxDate" appendTo="body" styleClass="w-100" [showIcon]="true" iconDisplay="input"
                (onSelect)="onDateSelect()">
            </p-calendar>
        </div>

        <!-- Actions -->
        <div class="col-xl-3 col-lg-12 col-md-6">
            <div class="filter-actions">
                <button pButton type="button" label="Reset" icon="pi pi-refresh"
                    class="p-button-outlined p-button-secondary" (click)="resetFilters()">
                </button>
            </div>
        </div>

    </div>

    @if(searchHint){
    <!-- <i class="text-muted small mt-1">
        <b class="p-button-secondary">Search Applied On:</b> {{ searchHint }}
    </i> -->
    <!-- <div class="filter-info mt-1">
        <i class="pi pi-info-circle me-2"></i>
        Search applied on:
        <span>{{searchHint}}</span>
    </div> -->
    }


</div>